export default __webpack_public_path__ + "static/media/aboutPic.efc2ab2e.png";